import { REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION } from '../../RequestProfileTabEmails.constants'

export function getRequestProfileTabEmailsItemActionsNotificationTitleKey(
  action
) {
  const keys = {
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AddNote]:
      'RequestProfile.TabEmailsAddNoteSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AttachToActivity]:
      'RequestProfile.TabEmailsAttachToActivitySuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Delete]:
      'RequestProfile.TabEmailsDeleteSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsRead]:
      'RequestProfile.TabEmailsMarkAsReadSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsStarred]:
      'RequestProfile.TabEmailsMarkAsStarredSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnread]:
      'RequestProfile.TabEmailsMarkAsUnreadSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnstarred]:
      'RequestProfile.TabEmailsMarkAsUnstarredSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToAnotherServiceRequest]:
      'RequestProfile.TabEmailsMoveToServiceRequestSuccessKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToTab]:
      'RequestProfile.TabEmailsMoveToTabSuccessKey',
  }

  return keys[action] || null
}

export function getRequestProfileTabEmailsItemActionsErrorTitleKey(action) {
  const keys = {
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AddNote]:
      'RequestProfile.TabEmailsAddNoteErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AttachToActivity]:
      'RequestProfile.TabEmailsAttachToActivityErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Delete]:
      'RequestProfile.TabEmailsDeleteErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsRead]:
      'RequestProfile.TabEmailsMarkAsReadErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsStarred]:
      'RequestProfile.TabEmailsMarkAsStarredErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnread]:
      'RequestProfile.TabEmailsMarkAsUnreadErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnstarred]:
      'RequestProfile.TabEmailsMarkAsUnstarredErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToAnotherServiceRequest]:
      'RequestProfile.TabEmailsMoveToServiceRequestErrorKey',
    [REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToTab]:
      'RequestProfile.TabEmailsMoveToTabErrorKey',
  }

  return keys[action] || null
}
